import { BaseDto } from "../base.dto";
import { PagingDto } from "../paging.dto";

export class AdminManageQaDto extends BaseDto {
  question: string;
  answer: string;
  mallIds?: string[];
  malls?: Array<{
    id: string;
    name: {
      en?: string;
      kh?: string;
    };
  }>;
}

export class FindManageQaDto extends PagingDto {
  question?: string;
  answer?: string;
  mallId?: string; // For filtering, still use mallId
}

export class CreateManageQaDto {
  question: string;
  answer: string;
  mallIds: string[];
}

export class UpdateManageQaDto {
  question?: string;
  answer?: string;
  mallIds?: string[];
}

